import { call, put, takeEvery, fork } from "redux-saga/effects";
import * as actions from "../actions/novedades";
import novedades from "../services/novedades";

function* getNovedadesByClienteId({ clienteId, contactoId }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      novedades.getNovedadesByClienteId,
      clienteId,
      contactoId,
    );
    if (response) {
      yield put(actions.getNovedadesByClienteIdSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getNovedadesByClienteIdError(err));
    console.log(err);
  }
}

function* getNovedadesMenuByClienteId({ clienteId, contactoId }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      novedades.getNovedadesMenuByClienteId,
      clienteId,
      contactoId,
    );
    if (response) {
      yield put(actions.getNovedadesMenuByClienteIdSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getNovedadesMenuByClienteIdError(err));
    console.log(err);
  }
}

function* marcarNovedadComoLeida({ clienteId, contactoId, novedadId }) {
  yield put(actions.startLoading());
  try {
    yield call(novedades.marcarNovedadComoLeida, {
      clienteId,
      contactoId,
      novedadId,
    });
    yield put(actions.marcarNovedadComoLeidaSuccess());
  } catch (err) {
    yield put(actions.getNovedadesMenuByClienteIdError(err));
    console.log(err);
  }
}

function* watchGetNovedadesByClienteId() {
  yield takeEvery(actions.Types.NOVEDADES_GET_REQUEST, getNovedadesByClienteId);
}
function* watchGetNovedadesMenuByClienteId() {
  yield takeEvery(
    actions.Types.NOVEDADES_GET_MENU_REQUEST,
    getNovedadesMenuByClienteId,
  );
}

function* watchMarcarNovedadComoLeida() {
  yield takeEvery(actions.Types.NOVEDADES_MARCAR_LEIDO, marcarNovedadComoLeida);
}

const novedadesSagas = [
  fork(watchGetNovedadesByClienteId),
  fork(watchGetNovedadesMenuByClienteId),
  fork(watchMarcarNovedadComoLeida),
];

export default novedadesSagas;
